module.exports = __webpack_public_path__ + "img/icon_gdyh.6659dc07.png";